import React, { useContext, useEffect, useRef, useState } from "react";
import _ from "lodash";

import { Divider, Grid, Typography, colors } from "@mui/material";

import { useTheme } from "@mui/material/styles";

import useResizeableContainer from "../../hooks/useResizeableContainer";

import Thumbnail from "./Thumbnail";
import ContainerLoading from "../Loading/ContainerLoading";

import ImageContext from "../../contexts/Image/ImageContext";
// import HttpContext from "../../contexts/HTTP/HttpContext";

function ProcessedImages(props) {
  const theme = useTheme();
  // const { get } = useContext(HttpContext);
  const { imageData } = useContext(ImageContext);

  const { imagesLoading } = props;

  const containerRef = useRef(null);
  const { containerSize } = useResizeableContainer({ containerRef });

  // const [loading, setLoading] = useState(true);

  return (
    <Grid
      ref={containerRef}
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h4">Processed Images</Typography>
          <Typography>View your processed images here</Typography>
        </div>
        <div></div>
      </div>
      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={imagesLoading} />
      <div
        style={{
          display: imagesLoading ? "none" : "flex",
          flexWrap: "wrap",
        }}
      >
        {imageData.processed.map((image) => (
          <Thumbnail
            key={image.file}
            size={Math.floor(containerSize.width * 0.15)}
            imageData={image}
          />
        ))}
      </div>
    </Grid>
  );
}

export default ProcessedImages;
